import { useUserTagDescriptionLang } from './useUserTagDescriptionLang';

import type { UserTagType } from 'shared/domain';

export function useUserTagDescription(props: Props) {
  const lang = useUserTagDescriptionLang(props);
  return {
    lang,
  };
}

interface Props {
  userTag: UserTagType;
}
